import Vue from 'vue'

const state = {
  listaDias: [],
  listaTurnos: [],
  listaLocais: [],
  listaHorarios: [],
  listaHorariosRodas: [],
  listaTemas: []
}

const mutations = {
  setDias (state, data) {
    state.listaDias = data
  },
  setTurnos (state, data) {
    state.listaTurnos = data
  },
  setLocais (state, data) {
    state.listaLocais = data
  },
  setHorarios (state, data) {
    state.listaHorarios = data
  },
  setHorariosRodas (state, data) {
    state.listaHorariosRodas = data
  },
  setTemas (state, data) {
    state.listaTemas = data
  }
}

const actions = {
  buscarDias (context, data) {
    Vue.http.post('api/beneficiarios/buscarDias', data).then(response => {
      context.commit('setDias', response.data.data.dias)
    })
  },
  buscarTurnos (context, data) {
    Vue.http.post('api/beneficiarios/buscarTurnos', data).then(response => {
      context.commit('setTurnos', response.data.data.turnos)
    })
  },
  buscarLocaisCombo (context, data) {
    Vue.http.post('api/beneficiarios/buscarLocais', data).then(response => {
      context.commit('setLocais', response.data.data.locais)
    })
  },
  buscarLocaisComboList (context, data) {
    Vue.http.post('api/beneficiarios/buscarLocaisList', data).then(response => {
      context.commit('setLocais', response.data.data.locais)
    })
  },
  buscarLocaisComboListPorCategoria (context, data) {
    Vue.http.post('api/beneficiarios/buscarLocaisListPorCategoria', data).then(response => {
      context.commit('setLocais', response.data.data.locais)
    })
  },
  buscarHorarios (context, data) {
    Vue.http.post('api/beneficiarios/buscarHorarios', data).then(response => {
      context.commit('setHorarios', response.data.data.horarios)
    })
  },
  buscarHorasRodas (context, data) {
    Vue.http.get('api/roda-horas', data).then(response => {
      context.commit('setHorariosRodas', response.data.data)
    })
  },
  buscarTemas (context, data) {
    Vue.http.get('api/roda-temas', data).then(response => {
      context.commit('setTemas', response.data.data)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/combos.js